import { useCallback } from 'react';
import { attendCall, rejectCall, endCall, toggleAudio, toggleVideo } from '../services/callService';

/**
 * ViewModel for IncomingCallScreen.
 * Wraps attend/reject service calls — UI file never imports sdkCallMethods.
 */
export const useIncomingCall = () => {
   const handleAttend = useCallback(() => attendCall(), []);
   const handleDecline = useCallback(() => rejectCall(), []);
   return { handleAttend, handleDecline };
};

/**
 * ViewModel for OutgoingCallScreen.
 * Wraps endCall service — UI file never imports sdkCallMethods.
 */
export const useOutgoingCall = (isAudioMuted, isVideoMuted) => {
   const handleEndCall = useCallback(() => endCall(), []);
   const handleToggleAudio = useCallback(() => toggleAudio(isAudioMuted), [isAudioMuted]);
   const handleToggleVideo = useCallback(() => toggleVideo(isVideoMuted), [isVideoMuted]);

   return { handleEndCall, handleToggleAudio, handleToggleVideo };
};
